__turbopack_context__.v({
  "all-courses": "all-courses-module-scss-module__EX5_WW__all-courses",
  "all-courses-carousel": "all-courses-module-scss-module__EX5_WW__all-courses-carousel",
  "carousel-slide": "all-courses-module-scss-module__EX5_WW__carousel-slide",
  "course-card": "all-courses-module-scss-module__EX5_WW__course-card",
  "drawer-inner": "all-courses-module-scss-module__EX5_WW__drawer-inner",
  "drawer-item": "all-courses-module-scss-module__EX5_WW__drawer-item",
  "drawer-item--expanded": "all-courses-module-scss-module__EX5_WW__drawer-item--expanded",
  "error": "all-courses-module-scss-module__EX5_WW__error",
  "header-row": "all-courses-module-scss-module__EX5_WW__header-row",
  "heading": "all-courses-module-scss-module__EX5_WW__heading",
  "loader": "all-courses-module-scss-module__EX5_WW__loader",
  "mobile-item": "all-courses-module-scss-module__EX5_WW__mobile-item",
  "mobile-list": "all-courses-module-scss-module__EX5_WW__mobile-list",
  "pager": "all-courses-module-scss-module__EX5_WW__pager",
  "pager-slot": "all-courses-module-scss-module__EX5_WW__pager-slot",
  "show-more-button": "all-courses-module-scss-module__EX5_WW__show-more-button",
  "show-more-item": "all-courses-module-scss-module__EX5_WW__show-more-item",
});
